<template>
  <div v-if="links && links.length > 0">
    <LvText h5 bold class="mb-8">
      {{ $t(title) }}
    </LvText>
    <LvTextCard
      v-for="(link, linkIndex) in links"
      :key="linkIndex"
      class="pa-4"
      :class="{ 'mb-16': linkIndex !== links.length - 1 }"
    >
      <template v-slot:content>
        <ListCard row isTable noPadding :white="bgWhite">
          <ListCardItem row isTable type="slot" title="名稱">
            <template #slot>
              <LlLink :textLabel="link.name" @click="$_onClickLink(link)" />
            </template>
          </ListCardItem>
          <ListCardItem
            v-if="link.recordLinks && link.recordLinks.length > 0"
            row
            isTable
            type="slot"
          >
            <template v-slot:title>
              <LvText h5 bold class="mt-4">
                {{ $t('關聯連結') }}
              </LvText>
            </template>
            <template #slot>
              <LvFlexBox>
                <LlLink
                  v-for="(recordLink, recordLinkIndex) in link.recordLinks"
                  :key="recordLinkIndex"
                  :textLabel="`[結果] ${recordLink.name} (${recordLink.createdAt})`"
                  class="mr-3 mt-2"
                  @click="$_onClickLink(recordLink)"
                />
              </LvFlexBox>
            </template>
          </ListCardItem>
          <ListCardItem
            v-if="link.remark"
            row
            isTable
            type="text"
            title="備註"
            :textContent="link.remark"
          />
        </ListCard>
      </template>
    </LvTextCard>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '相關資料',
    },
    links: {
      type: Array,
      default: () => [],
    },
    bgWhite: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    $_onClickLink(link) {
      const { id, modulePageValue, url: linkUrl } = link;
      if (modulePageValue === 'checklist-assignment-temporary') {
        let finalUrl = linkUrl;
        try {
          const u = new URL(linkUrl, window.location.href);
          u.searchParams.set('link', String(id));
          const metaName = this.$route.meta && this.$route.meta.name;
          const routeName = this.$route.name;
          if (metaName === 'tasks') {
            u.searchParams.set('type', 'task');
            if (routeName === 'tasks') {
              u.searchParams.set('from', 'index');
            } else if (routeName === 'taskContent') {
              u.searchParams.set('from', 'show');
            }
          } else if (metaName === 'board' || metaName === 'oldBoard') {
            u.searchParams.set('from', 'board');
          }
          finalUrl = u.toString();
        } catch (e) {
          const separator = linkUrl.includes('?') ? '&' : '?';
          finalUrl = `${linkUrl}${separator}link=${encodeURIComponent(String(id))}`;
        }
        window.open(finalUrl, '_blank');
      } else {
        window.open(linkUrl, '_blank');
      }
    },
  },
};
</script>
